import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

var SvgLinkBroken = function SvgLinkBroken(props) {
  return _jsxs("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    role: "img"
  }, props), {}, {
    children: [_jsx("path", {
      fill: props.color || '#909090',
      d: "M7.873 3.881a2.998 2.998 0 0 1 4.243 0 3.004 3.004 0 0 1 0 4.246l-.705.705-1.97-.859h.001L1.75 4.628a.6.6 0 0 0-.39 1.132l1.258.548-.148.148a5.007 5.007 0 0 0 0 7.077 4.997 4.997 0 0 0 7.072 0l.58-.58a1.001 1.001 0 0 0-1.415-1.415l-.58.58a2.998 2.998 0 0 1-4.242 0 3.004 3.004 0 0 1 0-4.246l.704-.705 1.97.859-1.266 1.267a1.001 1.001 0 0 0 1.414 1.415L8.53 8.886l5.631 2.455a.6.6 0 1 0 .48-1.101L13.38 9.69l.149-.149a5.007 5.007 0 0 0 0-7.076 4.997 4.997 0 0 0-7.071 0l-.58.58a1.001 1.001 0 0 0 1.414 1.415l.58-.58Z"
    }), _jsx("path", {
      fill: props.color || '#909090',
      d: "m8.612 5.972 1.972.858.123-.124a1.001 1.001 0 0 0-1.414-1.415l-.681.681Z"
    })]
  }));
};

export default SvgLinkBroken;